// extracted by mini-css-extract-plugin
module.exports = {"pg-speech-box":"dx","pgSpeechBox":"dx","speech-list-box":"dy","speechListBox":"dy"};